export var SUCCESS_MSG = {
    ADDRESS: {
        ADDED: "An address has successfully been added to your account",
        DELETED: "An address has successfully been deleted from your account",
        DELIVERABLE: "You are in the delivery range for this location."
    },
    ORDER: {
        EMAIL_RECEIPT: "Receipt sent",
        PROPOSED: "Mobile order proposed",
        PROCESSED: "Mobile order processed",
        PLACED: "Your order has successfully been placed",
        PAYMENT: {
            CREATED: "Payment Account Created",
            ADDED: "Payment Account Added",
            DELETED: "Your payment account was successfully deleted",
            FLOW_BEGIN: "HPP Payment Account Setup Started",
            API_DELETION_MSG: "Payment Account Deleted",
            ACCOUNT_FOUND: "Payment Account Found"
        },
        STATUS: {
            ON_ITS_WAY: "Your order is on it's way",
            PICKUP_READY: "Your order is ready for pickup"
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/common/messages/success.msg.ts
// module id = zBAG
// module chunks = 18